<div class="lum-page lum-page__card lum-c-bom-form">
  <ng-container *ngIf="!isDialog">
    <header class="lum-page-header lum-page-header--sticky">
      <h2 class="lum-page-header__heading">
        <a [routerLink]="['/bom']">Bills of Materials</a> /
        <ng-container *ngIf="bomId">
          <a [routerLink]="['/bom/view', bomId]">{{ bom?.name }}</a> / Edit
        </ng-container>
        <ng-container *ngIf="!bomId">Create New</ng-container>
      </h2>
      <div class="lum-page-header__actions">
        <lum-ui-button [loading]="submittingForm" (clickEvent)="onSubmit()">
          <lum-ui-icon icon="content-save"></lum-ui-icon>
          Save
        </lum-ui-button>
      </div>
    </header>
    <div class="lum-page-content">
      <ng-container *ngTemplateOutlet="bomForm"></ng-container>
    </div>
  </ng-container>

  <ng-container *ngIf="isDialog">
    <div class="p-5">
      <div class="d-flex justify-content-between">
        <div class="align-self-center">
          <h3 class="mt-4 inline">
            {{ !bomId ? 'Create' : 'Update' }} Bill of Materials
          </h3>
        </div>
        <div class="align-self-center">
          <button
            type="button"
            class="lum-button lum-button--secondary"
            mat-button
            (click)="dialogRef.close()"
          >
            <lum-ui-icon
              class="mr-2-5"
              icon="close-circle"
              color="#5563D6"
              width="23"
              height="23"
            ></lum-ui-icon>
            Close
          </button>
        </div>
      </div>
      <mat-divider class="my-2"></mat-divider>
    </div>
    <ng-container *ngTemplateOutlet="bomForm"></ng-container>
  </ng-container>
</div>

<ng-template #bomForm>
  <form [formGroup]="form">
    <div class="row mb-4 justify-content-between">
      <div class="col-8 col-sm-6 col-md-5 col-lg-4">
        <label>Name</label>
        <input
          formControlName="name"
          type="text"
          required="true"
          class="lum-input"
        />
        <mat-error *ngIf="form.get('name')?.invalid">
          {{ form.get('name') | validateField }}
        </mat-error>
      </div>
    </div>
    <div class="row mb-4">
      <div class="col-12">
        <div>
          <table class="lum-table lum-table--classic striped">
            <thead>
              <tr>
                <th>&nbsp;</th>
                <th class="w-p35">SKU</th>
                <th class="w-p15">Quantity</th>
                <th class="w-p15">Unit <span class="text-red-700">*</span></th>
                <th class="w-10">Unit Price</th>
                <th class="w-15">Total Price</th>
                <th class="w-45">Notes</th>
                <th>&nbsp;</th>
              </tr>
            </thead>
            <tbody
              id="bom-items"
              cdkDropList
              (cdkDropListDropped)="drop($event)"
              formArrayName="items"
            >
              <ng-container
                *ngFor="
                  let item of itemsFormArray?.controls;
                  trackBy: trackByControlValue;
                  let i = index
                "
              >
                <tr
                  cdkDrag
                  cdkDragLockAxis="y"
                  [formGroupName]="i"
                  id="row-bom{{ i }}"
                  [lumTableAnimateRow]="item.value.sku"
                >
                  <td>
                    <lum-ui-icon
                      cdkDragHandle
                      class="mr-2 cursor-grab"
                      icon="menu"
                      color="#36363A"
                    ></lum-ui-icon>
                  </td>
                  <td>
                    <lum-rfq-list-dropdown
                      placeholder="Search SKU or Product Name"
                      [rfqType]="'PRODUCT'"
                      [displayValue]="
                        !item.value?.rfqId
                          ? ''
                          : item.value?.sku?.value?.productName +
                            ' [' +
                            item.value?.sku?.value?.sku +
                            ']'
                      "
                      (selectOptionEvent)="onSelectRfq($event, item)"
                    ></lum-rfq-list-dropdown>
                  </td>
                  <td>
                    <input
                      type="number"
                      inputmode="numeric"
                      class="lum-input"
                      formControlName="quantity"
                      lumDebounceTime
                      (debounceValue)="onQuantityChange($event, item)"
                    />
                  </td>
                  <td>
                    <mat-select
                      class="lum-select"
                      formControlName="uomId"
                      (selectionChange)="onUnitChange($event, item)"
                    >
                      <mat-option
                        *ngFor="
                          let unit of item.value?.sku?.value?.unitOfMeasures || []
                        "
                        [value]="unit.id"
                      >
                        {{ unit.name }}
                      </mat-option>
                    </mat-select>
                  </td>
                  <td>
                    {{ item?.value?.unitPrice }}
                  </td>
                  <td>
                    {{ item?.value?.totalPrice | currency }}
                  </td>
                  <td>
                    <input type="text" class="lum-input" formControlName="note" />
                  </td>

                  <td class="actions">
                    <button
                      class="lum-button lum-button--small lum-button--link"
                      mat-icon-button
                      (click)="onRemoveItem(i)"
                    >
                      <lum-ui-icon
                        icon="minus-circle"
                        [width]="16"
                        [height]="16"
                        color="#3a47af"
                      ></lum-ui-icon>
                      <span class="sr-only">Remove Item</span>
                    </button>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
        <div class="mt-4">
          <button
            type="button"
            class="lum-button lum-button--dotted lum-button--full-width"
            [matMenuTriggerFor]="menu"
          >
            Add Row(s)
          </button>
          <mat-menu
            class="lum-mat-menu"
            #menu="matMenu"
            yPosition="above"
            xPosition="before"
          >
            <button mat-menu-item (click)="onAddMultipleItems(1)">
              Add 1 Row
            </button>
            <button mat-menu-item (click)="onAddMultipleItems(5)">
              Add 5 Rows
            </button>
            <button mat-menu-item (click)="onAddMultipleItems(10)">
              Add 10 Rows
            </button>
            <button mat-menu-item (click)="onAddMultipleItems(25)">
              Add 25 Rows
            </button>
            <button mat-menu-item (click)="onAddMultipleItems(50)">
              Add 50 Rows
            </button>
          </mat-menu>
        </div>
      </div>
    </div>
    <div *ngIf="isDialog" class="d-flex justify-content-end">
      <lum-ui-button [loading]="submittingForm" (clickEvent)="onSubmit()">
        <lum-ui-icon icon="content-save"></lum-ui-icon>
        Save
      </lum-ui-button>
    </div>
  </form>
</ng-template>
